



















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import moment from 'moment';

@Component
export default class DateTimeField extends Vue {
  @Prop(String) public label;
  @Prop(String) public readonly field!: string;
  @Prop(String) public readonly datesourcefield!: string;
  @Prop(Object) public readonly rec!: object;
  @Prop() public readonly rules!: any;
  @Prop({ type: String, default: '3' }) public readonly labelCols!: string;
  @Prop({ type: String, default: '9' }) public readonly inputCols!: string;
  @Prop({ type: Boolean, default: false }) public readonly isReadOnly!: boolean;
  @Prop({ type: Boolean, default: false }) public readonly clearable!: boolean;

  public datetimeValue = this.parseDateTimeUTC(this.rec[this.field]);
  public hours = this.datetimeValue ? this.formatNumber(this.datetimeValue.hour().toString()) : '';
  public minutes = this.datetimeValue ? this.formatNumber(this.datetimeValue.minute().toString()) : '';
  public dateText = this.formatDateText(this.datetimeValue);
  public datePick = this.formatDatePick(this.datetimeValue);
  public datePickMenu = false;

  public saveTime() {
    // console.log('DateTimeField.saveTime', this.hours, this.minutes);
    // Check if input is valid
    const validHours = this.checkValidHours();
    const validMinutes = this.checkValidMinutes();
    // Format valid inputs and remove invalid inputs
    if (validHours && this.minutes === '') {
      this.minutes = '00';
    }
    if (!validHours) {
      // Reset time and empty minutes field
      this.minutes = '';
      this.setTime(null);
    } else if (!validMinutes) {
      // Reset time and set default minutes field
      this.minutes = '00';
      this.setTime(moment().hour(this.parseNumber(this.hours)).minute(0).second(0));
    } else {
      // Save time
      this.setTime(moment().hour(this.parseNumber(this.hours)).minute(this.parseNumber(this.minutes)).second(0));
    }
  }

  public dateTextBlur() {
    // console.log('DateTimeField.dateTextBlur', this.dateText);
    this.setDate(this.parseDateText(this.dateText));
  }

  public dateTextInput() {
    // console.log('DateTimeField.dateTextInput', this.dateText);
    this.setDate(this.parseDateText(this.dateText));
  }

  public setTime(dt: moment.Moment | null) {
    // console.log('DateTimeField.setTime', this.formatDateTimeLocal(dt), this.formatDateTimeLocal(this.datetimeValue));
    if (dt) {
      if (this.datetimeValue) {
        if (this.datetimeValue.hour() !== dt.hour() || this.datetimeValue.minute() !== dt.minute()) {
            this.setDateTime(moment(this.datetimeValue).local().hour(dt.hour()).minute(dt.minute()));
        } else {
          // console.log('DateTimeField.setTime no action');
        }
      } else {
        // console.log('DateTimeField.setTime this.datetimeValue empty', this.formatDateTimeLocal(dt), this.formatDateTimeLocal(this.datetimeValue));
        if (this.datesourcefield && this.rec[this.datesourcefield]) {
          const srcDate = this.parseDateTimeUTC(this.rec[this.datesourcefield]);
          // console.log('DateTimeField.setTime re-use srcDate', this.formatDateTimeLocal(srcDate));
          this.setDateTime(moment(srcDate).hour(dt.hour()).minute(dt.minute()));
        } else {
          this.setDateTime(dt);
        }
      }
    } else {
      // console.log('DateTimeField.setTime null');
      this.setDateTime(null);
    }
  }

  public setDate(dt: moment.Moment | null) {
    // console.log('DateTimeField.setDate', this.field, this.formatDateTimeLocal(this.datetimeValue), '->', this.formatDateTimeLocal(dt));
    if (dt) {
      if (this.datetimeValue) {
          if (!this.datetimeValue.isSame(dt, 'day')) {
              this.setDateTime(moment(this.datetimeValue).year(dt.year()).month(dt.month()).date(dt.date()));
          } else {
            // console.log('\tDateTimeField.setDate no action');
          }
      } else {
        // console.log('\tDateTimeField.setDate this.datetimeValue empty');
        this.setDateTime(dt);
      }
    } else {
      // console.log('\tDateTimeField.setDate null');
      this.setDateTime(null);
    }
  }

  public setDateTimeValue(dt: moment.Moment | null) {
    // console.log('DateTimeField.setDateTimeValue', this.field, dt);
    this.datetimeValue = dt;
    this.hours = dt ? this.formatNumber(dt.local().hour().toString()) : '';
    this.minutes = dt ? this.formatNumber(dt.minute().toString()) : '';
    this.dateText = this.formatDateText(dt);
    this.datePick = this.formatDatePick(dt);
  }

  public setDateTime(dt: moment.Moment | null) {
    this.setDateTimeValue(dt);
    this.rec[this.field] = this.formatDateTimeUTC(dt);
    this.$emit('change', dt);
    console.log('DateTimeField.setDateTime', this.field, dt, this.rec[this.field]);
}

  public formatDateTimeLocal(value: moment.Moment | null): string | null {
    return value ? moment(value).local().format() : null;
  }
  public formatDateTimeUTC(value: moment.Moment | null): string | null {
    return value ? moment(value).utc().format() : null; // make a copy
  }
  public formatDateText(value: moment.Moment | null): string | null {
    return value ? value.format('DD-MM-YYYY') : null;
  }
  public formatDatePick(value: moment.Moment | null): string | null {
    return value ? value.format('YYYY-MM-DD') : null;
  }

  public parseDateTimeUTC(value: string | null): moment.Moment | null {
    // console.log('DateTimeField.parseDateTimeUTC', this.field, value);
    return value ? moment.utc(value).local() : null;
  }
  public parseDateText(value: string | null): moment.Moment | null {
    // console.log('DateTimeField.parseDateText', this.field, value);
    return value ? moment.utc(value, 'DD-MM-YYYY', true).local() : null;
  }
  public parseDatePick(value: string | null): moment.Moment | null {
    // console.log('DateTimeField.parseDatePick', this.field, value);
    return value ? moment(value, 'YYYY-MM-DD', true).local() : null;
  }

  public datePickChanged() {
    // console.log('DateTimeField.datePickChanged', this.field, this.datePick);
    this.datePickMenu = false;
    const dt = this.parseDatePick(this.datePick);
    this.dateText = this.formatDateText(dt);
    this.setDate(dt);
  }

  // Return true if the input is a valid number of hours
  public checkValidHours(): boolean {
    // console.log('DateTimeField.checkValidHours', this.hours);
    if (this.hours.length === 1 || this.hours.length === 2) {
      if (this.parseNumber(this.hours) < 24) {
        this.hours = this.formatNumber(this.hours);
        return true;
      } else {
        this.hours = '';
        return false;
      }
    } else {
      this.hours = '';
      return false;
    }
  }

  // Return true if the input is a valid number of minutes
  public checkValidMinutes(): boolean {
    // console.log('DateTimeField.checkValidMinutes', this.minutes);
    if (this.minutes.length === 1 || this.minutes.length === 2) {
      const n = this.parseNumber(this.minutes);
      if (n < 60) {
        if (n % 15 !== 0) {
          this.minutes = (Math.round(n / 15.0) * 15).toString();
        }
        this.minutes = this.formatNumber(this.minutes);
        return true;
      } else {
        this.minutes = '';
        return false;
      }
    } else {
      this.minutes = '';
      return false;
    }
  }

  // Add leading zero if the number has only one digit
  public formatNumber(n: string): string {
    // console.log('DateTimeField.formatNumber', n, n.length === 1 ? '0' + n : n);
    return n.length === 1 ? '0' + n : n;
  }

  // Parse string to valid number, remove leading zeros
  public parseNumber(n: string): number {
    // console.log('DateTimeField.parseNumber', n);
    return Number(n.replace(/^0+/, ''));
  }

  public nextElement(e) {
    // console.log('DateTimeField.nextElement');
    const elem = e.target;
    const currentIndex = Array.from(elem.form.elements).indexOf(elem);
    let nextElem = elem.form.elements.item(
      currentIndex < elem.form.elements.length - 1 ? currentIndex + 1 : 0
    );
    if (nextElem.tabIndex === -1) {
      // Skip element - clear icon
      nextElem = elem.form.elements.item(
        currentIndex < elem.form.elements.length - 2 ? currentIndex + 2 : 0
      );
    }
    nextElem.select();
    this.$emit('enter', e);
  }

  public created() {
    this.$watch(
      function() { return this.rec[this.field]; },
      function(newValue, oldValue) {
          // console.log('DateTimeField.$watch', oldValue, '->',  newValue);
          if (oldValue !== newValue) {
            this.setDateTimeValue(this.parseDateTimeUTC(newValue));
          }
        }
    );
  }

}
